export default [
  {
    name: 'bank/collections',
    path: '/bank/collections',
    meta: { design: { classes: ['fill-height', 'bg--linear-gradient'] } },
    component: () => import('@/pages/bank/Collections.vue'),
  },
  {
    name: 'bank/withdrawal',
    path: '/bank/withdrawal',
    component: () => import('@/pages/bank/Withdrawal.vue'),
  },
]
